import { render } from "./teamLessonDiscuss.vue?vue&type=template&id=249f6fdf&scoped=true"
import script from "./teamLessonDiscuss.vue?vue&type=script&lang=js"
export * from "./teamLessonDiscuss.vue?vue&type=script&lang=js"

import "./teamLessonDiscuss.vue?vue&type=style&index=0&id=249f6fdf&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-249f6fdf"]])

export default __exports__